import { Flex } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["cover type"];

// const items = [
//   {
//     id: 1,
//     Item: "30 Day Admin",
//   },
// ];

function CoverTypes() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);

  const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);

  const navigate = useNavigate();

  const onNew = () => {
    navigate("/covertypesmanage", {
      state: {
        action: "covertypesmanage-add",
        data: {},
      },
    });
  };

  const onSelectItm = (data) => {
    setSelectedItem(data);
    navigate("/covertypesmanage", {
      state: {
        action: "covertypesmanage-edit",
        data: data?.item?.data,
      },
    });
  };

  const getList = (data) => {
    setIsLoading(true);
    api
      .getCovertypeAll({
        page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          console.log(res.data);
          if (data?.page) {
            setActivePage(data.page);
          }

          if (res?.data && res?.data[0]?.coverid) {
            const l = res.data.map((item) => ({
              id: item.coverid,
              covertype: item.covername,
              data: item,
            }));
            setList(l);
          } else {
            setList([]);
          }
        } else {
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
    });
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Cover Types"} isLoading={isLoading} />
      <Flex justifyContent="flex-end" gap={"1rem"} mb={"1rem"}>
        {/* <ButtonComp
          label="Open"
          onClick={onOpen}
          disabled={!selectedItem}
          keyname="open"
        /> */}
        <ButtonComp label="New" onClick={onNew} keyname="new" />
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default CoverTypes;
